const stockDrawClearTypes = {
  ALL: 'all',
  ANIMAL: 'animal',
  ATHLETE: 'athlete',
  TEAM: 'team',
};

export default stockDrawClearTypes;
